import * as config from '../../../config.ts'


export async function stampaCostoLavoro(data, token) {
    console.log('token', token);
    
    const res = await fetch(`${config.API_URL}/costo-lavoro/print/`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        "Authorization": token,
        },
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        throw new Error("Errore nella generazione del documento");
    }

    // scarica il file
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "costo_lavoro.docx";
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}
